import { TypedUseQueryHookResult } from '@reduxjs/toolkit/dist/query/react';

import { AxiosBaseQueryFunction } from '~/api/axiosBaseQuery';
import {
  PredefinedShapesParams,
  useFetchPredefinedShapesQuery,
} from '~/api/easy-estimator-api/predefined-shapes-api/predefinedShapesService';
import { PredefinedShape } from '~/core/models';

type usePredefinedShapesReturn = Omit<
  TypedUseQueryHookResult<
    PredefinedShape[],
    PredefinedShapesParams,
    AxiosBaseQueryFunction
  >,
  'data' | 'isFetching'
> & {
  predefinedShapes: PredefinedShape[];
  isFetchingPredefinedShapes: boolean;
};

const emptyArray = [] satisfies PredefinedShape[];

export const usePredefinedShapes = (): usePredefinedShapesReturn => {
  const {
    isFetching: isFetchingPredefinedShapes,
    data: predefinedShapes = emptyArray,
    ...rest
  } = useFetchPredefinedShapesQuery(undefined, {
    refetchOnFocus: false,
    refetchOnReconnect: false,
  });

  return {
    predefinedShapes,
    isFetchingPredefinedShapes,
    ...rest,
  };
};
